<template>
  <div 
    class="bim-tag"
    :class="[
    {
      'hover-effect': !nohover,
    },
    ]"
  >
    <span 
      class="bim-tag__text"
      :style="{
        fontSize
      }"
    >
      <slot>{{ label }}</slot>
    </span>
  </div>
</template>

<script>
export default {
  name: "BimTag",
  props: {
    /**
     * при true ховер эффекта не будет
     */
    nohover: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: String,
      default: "14px",
    },
    label: String,
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";
.bim-tag__text,
.bim-tag {
  display: inline-block;
}

.bim-tag {
  border: 1px solid $primary-color;
  color: $primary-color;
  border-radius: 2px;
}

.bim-tag.hover-effect:hover {
  background-color: $primary-color;
  color: $white-color;
}

.bim-tag__text {
  padding: 4px 8px;
}
</style>
